/* RESPONSIBLE TEAM: team-automation-foundations */
import type AnswerBot from 'embercom/models/operator/visual-builder/step/answer-bot';
import StepConfig, { type StepConfigParams } from '../step';

export default class AnswerBotConfiguration extends StepConfig {
  declare step: AnswerBot;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/answer-bot',
      ...params,
    });
  }
}
